import Flickity from 'flickity';

export default function block_events() {
	if ($('.felds-events-block .events').length == 0) return;

	var flkty = new Flickity( '.felds-events-block .events', {
		pageDots: false,
		initialIndex: '.is-initial-select'
	});
 
	flkty.select( $('.felds-events-block .events').data('start') );
}
